import { render, staticRenderFns } from "./HeadingNextTo.vue?vue&type=template&id=a56f7e1e&scoped=true&lang=pug&"
import script from "./HeadingNextTo.vue?vue&type=script&lang=js&"
export * from "./HeadingNextTo.vue?vue&type=script&lang=js&"
import style0 from "./HeadingNextTo.vue?vue&type=style&index=0&id=a56f7e1e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56f7e1e",
  null
  
)

export default component.exports